// extracted by mini-css-extract-plugin
export default {"filters":"DCompanyDirectoryPage_filters__oUEft","table":"DCompanyDirectoryPage_table__Hd2pq","sideColumn":"DCompanyDirectoryPage_sideColumn__t4Pl-"};